export function splitArray(data) {
	const arr = data ? data.split(',') : [];
	return arr.map(item => item.trim()) || [];
}

export function checkElementInArray(element, array) {
	array = array.map(elem => elem.toLowerCase());
	return array.indexOf(element.trim().toLowerCase()) > -1 ? true : false;
}
